




















import Vue from 'vue';

export default Vue.extend({
  name: "ConnectionListPanelMunicipal.vue",
  components: {},
  data(): {

  }{ return {

  }
  },
  methods: {
    async loadData() {
      // do something
    }
  },
  mounted: async function() {
    await this.loadData();
  }
} )

